import { DEFAULT_INVOICES } from 'shared/constants/payments';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_PAYMENTS_UI_FLAG]($state, payload) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...payload,
    };
  },

  [types.SET_PAYMENTS_ACCOUNT]($state, account) {
    $state.paymentsAccount = account;
  },

  [types.SET_PAYMENTS_INVOICES]($state, invoices) {
    $state.invoices = invoices;
  },

  [types.CLEAR_PAYMENTS_ACCOUNT]($state) {
    $state.paymentsAccount = {};
  },

  [types.CLEAR_PAYMENTS_INVOICES]($state) {
    $state.invoices = DEFAULT_INVOICES;
  },

  [types.SET_PAYMENT_STATUS]($state, paymentStatus) {
    $state.paymentStatus = paymentStatus;
  },

  [types.CLEAR_PAYMENT_STATUS]($state) {
    $state.paymentStatus = null;
  },
};
